import React from "react";
import { useProductStartDates } from "../../../hooks/useProductStartDates";
import { useSupportedProductStartDate } from "../../../hooks/useSupportedProductStartDate";
import { BottomMenuPanel } from "../../bottom-menu-panel";
import { BottomMenuButtons } from "../../bottom-menu/buttons";
import { StartDateOption } from "./start-date-option";

import "./start-date-selection-panel.css";

export const StartDateSelectionBottomMenuPanel = () => {
	const [startDates] = useProductStartDates();
	const supportedStartDate = useSupportedProductStartDate();

	if (!supportedStartDate) return null;

	return (
		<BottomMenuPanel className="start-date-selection-panel-container">
			<BottomMenuButtons>
				{startDates.map((date) => (
					<StartDateOption key={date} startDate={date} type={supportedStartDate} />
				))}
			</BottomMenuButtons>
		</BottomMenuPanel>
	);
};
